import React from 'react';
import { useLanguage } from './LanguageContext';

const translations = {
  en: {
    tagline: 'Your fridge has more potential than you think.',
    quickLinks: 'Explore',
    legal: 'Legal',
    copyright: '© 2025 Chaiffy. All rights reserved.',
    home: 'Home',
    features: 'Features',
    howItWorks: 'How It Works',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
    serviceInfo: 'This service is available to Mobily customers for 11.5 SAR (including VAT) renewed weekly.',
    cancelText: 'To cancel your subscription please click here:',
    cancelLink: 'http://infomob.digitalcg.net',
    cancelLabel: 'Cancel Subscription',
  },
  ar: {
    tagline: 'ثلاجتك فيها إمكانيات أكثر مما تتوقع.',
    quickLinks: 'استكشف',
    legal: 'قانوني',
    copyright: '© 2025 Chaiffy. جميع الحقوق محفوظة.',
    home: 'الرئيسية',
    features: 'المميزات',
    howItWorks: 'كيف يعمل',
    privacy: 'سياسة الخصوصية',
    terms: 'شروط الخدمة',
    serviceInfo: 'هذه الخدمة متاحة لعملاء موبايلي بسعر 11.5 ريال سعودي (شامل الضريبة) تُجدد أسبوعياً.',
    cancelText: 'لإلغاء اشتراكك يرجى الضغط هنا:',
    cancelLink: 'http://infomob.digitalcg.net',
    cancelLabel: 'إلغاء الاشتراك',
  }
};

const Footer = () => {
  const { language, isRTL } = useLanguage();
  const t = translations[language];

  return (
    <footer className="bg-dark text-white" dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="container mx-auto max-w-6xl px-4">
        <div className="grid md:grid-cols-3 gap-10 py-14 border-b border-gray-800">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <span className="text-xl">🍳</span>
              <span className="text-lg font-bold" style={{ fontFamily: 'Poppins, sans-serif' }}>Chaiffy</span>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed max-w-xs" style={{ fontFamily: 'Lato, sans-serif' }}>
              {t.tagline}
            </p>
          </div>
          
          <div className="flex gap-16">
            <div>
              <h4 className="font-semibold text-gray-300 text-sm mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                {t.quickLinks}
              </h4>
              <ul className="space-y-2.5" style={{ fontFamily: 'Lato, sans-serif' }}>
                <li><a href="#" className="text-gray-500 hover:text-white transition-colors text-sm">{t.home}</a></li>
                <li><a href="#features" className="text-gray-500 hover:text-white transition-colors text-sm">{t.features}</a></li>
                <li><a href="#how-it-works" className="text-gray-500 hover:text-white transition-colors text-sm">{t.howItWorks}</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold text-gray-300 text-sm mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                {t.legal}
              </h4>
              <ul className="space-y-2.5" style={{ fontFamily: 'Lato, sans-serif' }}>
                <li><a href="/privacy.html" className="text-gray-500 hover:text-white transition-colors text-sm">{t.privacy}</a></li>
                <li><a href="/terms.html" className="text-gray-500 hover:text-white transition-colors text-sm">{t.terms}</a></li>
              </ul>
            </div>
          </div>

          <div className="bg-gray-800/40 rounded-xl p-5">
            <p className="text-gray-400 text-xs leading-relaxed mb-2" style={{ fontFamily: 'Lato, sans-serif' }}>
              {t.serviceInfo}
            </p>
            <p className="text-gray-500 text-xs" style={{ fontFamily: 'Lato, sans-serif' }}>
              {t.cancelText}{' '}
              <a href={t.cancelLink} className="text-emerald-400 hover:text-emerald-300 underline transition-colors" target="_blank" rel="noopener noreferrer">
                {t.cancelLabel}
              </a>
            </p>
          </div>
        </div>
        
        <div className="py-6 text-center">
          <p className="text-gray-600 text-xs" style={{ fontFamily: 'Lato, sans-serif' }}>
            {t.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
